import React, { FocusEventHandler, useContext } from 'react';
import { Label, Select } from '@rebass/forms';
import { FocusContext } from '../../../contexts/FocusContext';
import { ErrorMessage } from './ErrorMessage';
import { useFormikContext } from 'formik';
import { space } from '../../../theme';
import { Box } from 'rebass';
import { SelectProps } from '@rebass/forms';
import DownChevron from '../../../icons/down-chevron.svg';

export interface DropDownOption {
  label: string;
  value?: string;
  disabled?: boolean;
}

export interface DropDownFieldProps extends SelectProps {
  name: string;
  label: string;
  options: DropDownOption[];
  defaultValue?: string;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  validateOnBlur?: boolean;
}
export const DropDownField: React.FC<DropDownFieldProps> = props => {
  const { name, label, options, validateOnBlur } = props;
  const { setFocus } = useContext(FocusContext);

  let { handleChange, handleBlur, errors, touched, values } = useFormikContext<
    any
  >();
  const hasError = !!touched[name] && errors && errors[name];
  const value = values[name];
  const errorName = `errorFor${name[0].toUpperCase() + name.substr(1)}`;

  const focusHandler: FocusEventHandler = () => setFocus(true);
  const blurHandler: FocusEventHandler = e => {
    setFocus(false);
    if (validateOnBlur) {
      handleBlur(e);
    }
  };

  const dropDownSelectionChangeHandler = (
    e: React.ChangeEvent<HTMLSelectElement>
  ) => {
    handleChange(e);
    if (props.onChange) {
      props.onChange(e);
    }
  };

  return (
    <Box sx={{ '& svg': { display: 'none' } }} maxWidth={props.maxWidth}>
      <Label htmlFor={name} variant="label">
        {label}
      </Label>
      <Select
        as={'select'}
        tx={'forms'}
        sx={{
          backgroundImage: `url(${DownChevron})`,
        }}
        aria-describedby={errorName}
        name={name}
        px={space.half}
        py={space.quarter}
        id={name}
        data-testid={name}
        onFocus={focusHandler}
        onChange={dropDownSelectionChangeHandler}
        onBlur={blurHandler}
        value={value}
        variant={hasError ? 'dropdown.error' : 'dropdown'}
      >
        {options &&
          options.map(({ label, ...rest }, idx) => (
            <option key={`name-${idx}`} {...rest}>
              {label}
            </option>
          ))}
      </Select>
      {hasError && (
        <ErrorMessage name={name} errors={errors} errorName={errorName} />
      )}
    </Box>
  );
};
